import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/insights/')({
  loader: ({ params }) => {
    throw redirect({
      to: '/org/$org/loop/$loopId/insights/mock',
      params: { org: params.org, loopId: params.loopId },
    });
  },
});
